import React, { useEffect, useState } from "react";
import cn from "classnames";
import { MinesDataInterface } from "../index";
import { MineItem, MineTypeFilter } from "./mineTypeFilter";
import { ReactComponent as CloseIcon } from "../../../assets/icons/close.svg";
import { ReactComponent as LogoIcon } from "../../../assets/icons/logo.svg";
import styles from "./filter.module.css";

export type MinesDataFilter = (data: MinesDataInterface) => MinesDataInterface;

interface FilterProps {
  mineTypes: MineItem[];
  onFilterFunction?: (func: MinesDataFilter) => void;
  onClose?: () => void;
  loading?: boolean;
  onFiltered?: (filtered: boolean) => void;
}

interface FilterInterface {
  mineTypes: string[];
}

const initialFilterState: FilterInterface = {
  mineTypes: [],
};
export const Filter = ({ mineTypes, onFilterFunction, onFiltered, onClose, loading }: FilterProps) => {
  const [filter, setFilter] = useState<FilterInterface>(initialFilterState);

  useEffect(() => {
    if (filter === initialFilterState) {
      return;
    }

    onFilterFunction &&
      onFilterFunction((data) => {
        const features = data.features.filter((feature) => {
          const currentMineType = feature.properties.Mine_Type || "";

          return filter.mineTypes.length > 0 ? filter.mineTypes.includes(currentMineType) : true;
        });

        return {
          ...data,
          features,
        };
      });

    onFiltered && onFiltered(filter.mineTypes.length > 0);
  }, [filter]);

  const mineTypeOnChange = (keys: string[]) => {
    setFilter((prev) => {
      return { ...prev, mineTypes: keys };
    });
  };

  const clearFilters = () => {
    setFilter({ mineTypes: [] });
  };

  return (
    <>
      <div className={styles.filtersMobileHeader}>
        <LogoIcon className={styles.logoIcon} />
        <CloseIcon className={styles.closeIcon} onClick={onClose} />
      </div>

      <div className={cn(styles.row, styles.filterHeader)}>
        <h4 className={styles.filterTitle}>Filter By:</h4>
        <span onClick={clearFilters} className={styles.clearFilters}>
          Clear filters
        </span>
      </div>

      <div className={styles.filters}>
        <div>
          <MineTypeFilter onChange={mineTypeOnChange} options={mineTypes} open={!loading} value={filter.mineTypes} />
        </div>
      </div>
    </>
  );
};
